<template>
  <div class="help-center-breadcrumbs__component">
    <template
      v-for="crumb in crumbs"
      :key="crumb.url"
    >
      <a
        :href="crumb.url"
        :class="crumb.class"
        class="help-center-breadcrumbs__link"
      >
        {{ crumb.title }}
      </a>
      <HelpCenterIcon
        v-if="!crumb.isLast"
        class="help-center-breadcrumbs__icon"
        name="chevronRight"
        size-units="5"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'

const props = defineProps({
  post: Object,
  tabMap: {
    type: Object,
    required: true
  },
  categoryMap: {
    type: Object,
    required: true
  },
  breadcrumbs: {
    type: Array,
    required: true
  }
})

const kinds = computed(() => {
  return {
    tab: props.tabMap,
    post: { [props.post?.url]: props.post },
    category: props.categoryMap
  }
})

const crumbs = computed(() => {
  return props.breadcrumbs.map(({ kind, url }, index) => {
    const isLast = index === props.breadcrumbs.length - 1

    return {
      url,
      class: isLast ? 'help-center-breadcrumbs__link--selected' : null,
      title: kinds.value[kind][url]?.title ?? 'Undefined',
      isLast
    }
  })
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-breadcrumbs {
  &__component {
    gap: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__link {
    @include help-center-muted-link;
    @include help-center-font(14);
    text-wrap: balance;

    &--selected {
      @include help-center-accent-link;
    }
  }

  &__icon {
    color: var(--help-center-muted);
  }
}
</style>
